import styled from "@emotion/styled";

import {
    breakpoints,
    colors,
    fontSizes,
    fontWeights,
    mediaQuery,
    votColorVariables,
} from "@gumtree/ui-library/src/base/theme";

export const DesktopTopLocationsContainer = styled.section`
    background: ${colors.white};
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;

    h2 {
        align-items: center;
        color: #101824;
        display: flex;
        flex-direction: column;
        font-size: 16px;
        font-weight: ${fontWeights.bold};
        gap: 4px;
        line-height: 24px;
        margin: 0;
        width: fit-content;

        &:after {
            background: #0a6cff;
            border-radius: 4px;
            content: "";
            display: block;
            height: 4px;
            width: 24px;
        }
    }

    .top-locations-columns {
        display: grid;
        gap: 24px;
        grid-template-columns: repeat(5, minmax(0, 1fr));
        width: 100%;
    }

    .link-list {
        margin: 0;
        text-align: left;
        width: 100%;

        .item {
            display: block;
            margin: 0 0 8px;
            text-align: left;

            &:after {
                display: none;
            }

            .link {
                color: #101824;
                display: inline;
                font-size: 14px;
                font-weight: ${fontWeights.normal};
                line-height: 22px;
                padding: 0;
                text-align: left;
            }
        }
    }
`;

export const ModernTopLocationsContainer = styled.section`
    display: flex;
    flex-direction: column;
    gap: 8px;
    box-sizing: border-box;
    width: 100%;
    padding: 16px;
    background: ${colors.white};

    h2 {
        margin: 0;
        color: #0c132d;
        font-size: ${fontSizes.xlarge};
        font-weight: ${fontWeights.bolder};
        line-height: 28px;
    }

    .top-locations-columns {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 0 12px;
    }

    .link-list {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        width: 100%;
        margin: 0;
        text-align: left;

        .item {
            display: block;
            margin: 0;

            :after {
                display: none;
            }

            .link {
                padding: 0;
                color: #56575c;
                font-size: ${fontSizes.base};
                font-weight: ${fontWeights.normal};
                line-height: 24px;
            }
        }
    }
`;

export const VotTopLocationsContainer = styled.section`
    box-sizing: border-box;
    width: 100%;

    .vot-top-locations-groups {
        align-items: center;
        display: grid;
        gap: 8px 12px;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        width: 100%;

        .link-list {
            display: contents;
            margin: 0;
            padding: 0;
        }

        .item {
            display: block;
            margin: 0;
            min-width: 0;

            &:after {
                display: none;
            }

            .link {
                color: ${votColorVariables.textPrimary};
                display: block;
                font-size: 14px;
                font-weight: ${fontWeights.normal};
                line-height: 22px;
                padding: 0;
                text-align: left;
                white-space: normal;
            }
        }
    }

    ${mediaQuery.from(breakpoints.medium)} {
        .vot-top-locations-groups {
            gap: 8px 24px;
            grid-template-columns: repeat(5, minmax(0, 1fr));

            .item .link {
                font-size: var(--vip-vot-browse-links-font-size);
                line-height: var(--vip-vot-browse-links-line-height);
                white-space: nowrap;
            }
        }
    }
`;
